import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Package, AlertTriangle, Truck, ShoppingCart } from 'lucide-react';
import type { DiscrepancySummaryData } from '@/types/discrepancy-review.types';

interface Props {
  summary: DiscrepancySummaryData;
}

const stats = [
  { key: 'total' as const, label: 'Total Items', icon: Package, color: 'text-blue-600 bg-blue-50' },
  { key: 'withDiscrepancy' as const, label: 'Con Diferencia', icon: AlertTriangle, color: 'text-amber-600 bg-amber-50' },
  { key: 'transfers' as const, label: 'Transferencias', icon: Truck, color: 'text-purple-600 bg-purple-50' },
  { key: 'purchaseOrders' as const, label: 'Órdenes de Compra', icon: ShoppingCart, color: 'text-green-600 bg-green-50' },
];

export const DiscrepancySummary: React.FC<Props> = ({ summary }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {stats.map(({ key, label, icon: Icon, color }) => (
        <Card key={key}>
          <CardContent className="pt-4 pb-4">
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-lg ${color}`}>
                <Icon className="h-5 w-5" />
              </div>
              <div>
                <p className="text-2xl font-bold text-gray-900">{summary[key]}</p>
                <p className="text-xs text-gray-500">{label}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
